/**
 * @generated SignedSource<<55153be2c538e8da1fe34ba9b8ea23dc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedSocialShareEmail_viewer$data = {
  readonly isPdpStfEnabled?: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSendToFriendModalLazy_viewer">;
  readonly " $fragmentType": "PdpSharedSocialShareEmail_viewer";
};
export type PdpSharedSocialShareEmail_viewer$key = {
  readonly " $data"?: PdpSharedSocialShareEmail_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSocialShareEmail_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchPdp"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSocialShareEmail_viewer",
  "selections": [
    {
      "condition": "fetchPdp",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "isPdpStfEnabled",
          "args": [
            {
              "kind": "Literal",
              "name": "feature",
              "value": "enablePdpStf"
            }
          ],
          "kind": "ScalarField",
          "name": "featureFlag",
          "storageKey": "featureFlag(feature:\"enablePdpStf\")"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedSendToFriendModalLazy_viewer"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "2f45368bd23ed2934bca639cc21bb306";

export default node;
